import { IApplicationState } from '../../types/redux';

export function selectQueryString(state: IApplicationState) {
  return state.queryString;
}
